import ApiBase from '../api-base'
import { PUBLIC } from '../constants'

export default class Otp extends ApiBase {
  constructor(store) {
    const path = `${PUBLIC}/otp`
    super(store, path)
  }

  send(operation, model, showProgress) {
    return this._request({
      action: 'send',
      method: 'POST',
      params: { operation },
      body: model,
      showProgress
    })
  }
}
